import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "./utils/axios";
import Swal from "sweetalert2";
import Moment from "moment";
import "@/assets/tailwind.css";

import HeroHeader from "@/components/common/HeroHeader.vue";
import HeroFooter from "@/components/common/HeroFooter.vue";

const app = createApp(App);
app.use(store);
app.use(router);
app.component("global-top-header", HeroHeader);
app.component("global-footer", HeroFooter);
app.provide("$swal", Swal);
app.provide("$moment", Moment);
app.provide("$router", router);
app.provide("$axios", axios);
app.provide("$store", store);
app.mount("#app");